import BaseRestService from './baseRestService';
import { UsersRepository, DevicesRepository } from '../common/repositories/index';

const _serviceDependencies = ['$http', '$q', 'Util', 'DeviceRestService',
    'UserRestService'];

/**
 * @ngdoc service
 * @name rest.services.DeploymentUrlsRestService
 *
 * @description
 * This class contains methods used to retrieve information about deployment-urls
 * using http requests.
*/
export default class DeploymentUrlsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     * @param  {any} DeviceRestService
     * @param  {any} UserRestService
     */
    constructor($http, $q, Util, DeviceRestService, UserRestService) {

        super(
            $http, $q, Util, DeviceRestService, UserRestService,
            UsersRepository, DevicesRepository,
        );

    }

    /**
     * @ngdoc function
     * @name rest.services.DeploymentUrlsRestService#deploy
     * @methodOf rest.services.DeploymentUrlsRestService
     * @function
     *
     * @description
     * Makes the call to the deployment-urls endpoint to retreave download url or send email and sms
     *
     * @param {object} deploymentPayload deployment payload
     *
     * @returns {Promise} The promise of the call.
     */
    deploy(data) {

        const { appId, os } = data;

        // Check if we should use local config (only for mobile OS)
        if (os === 'android' || os === 'ios') {

            const localUrl = this.getLocalDownloadUrl(appId, os);
            if (localUrl) {

                // Make it asynchronous to match XHR behavior
                return this.$q.resolve({
                    data: {
                        data: {
                            attributes: {
                                download_url: localUrl,
                            },
                        },
                    },
                }).then(response =>
                    // Add a small delay to allow DOM to stabilize (like XHR calls)
                    this.$q((resolve) => {

                        setTimeout(() => resolve(response), 500);

                    }));

            }

        }

        const deploymentPayload = {
            data: {
                attributes: {
                    appId,
                    os: data.os,
                    license_number: data.license_number,
                    license_type: data.license_type,
                    download_source: (data.license_type === 'paid') ? 'wdp' : 'wdf',
                    beta: data.beta,
                },
            },
            meta: data.meta || {},
        };

        return super.create(deploymentPayload, 'deployment-urls/');

    }

    /**
     * Gets download URL from local configuration for mobile deployments
     */
    getLocalDownloadUrl(appId, os) {

        const { downloadUrls, fallbackPatterns } = CWCONFIG;

        if (!downloadUrls || !downloadUrls[os]) {

            return null;

        }

        // Find matching URL for the appId
        const matchingConfig = downloadUrls[os].find(configItem =>
            configItem.apps.includes(appId));

        if (matchingConfig) {

            return matchingConfig.url;

        }

        // Try fallback patterns
        if (fallbackPatterns && fallbackPatterns[os]) {

            const fallbackMatch = fallbackPatterns[os].find(fallback =>
                fallback.pattern.test(appId));

            if (fallbackMatch) {

                const fallbackConfig = downloadUrls[os].find(configItem =>
                    configItem.apps.includes(fallbackMatch.fallbackToApp));

                if (fallbackConfig) {

                    return fallbackConfig.url;

                }

            }

        }

        return null;

    }

}

_serviceDependencies.push(DeploymentUrlsRestService);

angular.module('rest.services')
    .service('DeploymentUrlsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/deploymentUrlsRestService.js